<template>
    <div
        class="virtual-scroll-spacer"
        :style="{ height: `${totalItems * cellHeight}px` }">
        <div
            class="render-window"
            :style="{ transform: `translateY(${windowOffset}px)` }">
            <virtual-table-row
                v-for="row in visibleRows"
                :key="row.index"
                :row-index="row.index"
                :item="row.item"
                :is-placeholder="row.isPlaceholder"
                :headers="headers"
                :clickable="true"
                :column-widths="columnWidths"
                :cell-height="cellHeight"
                :scoped-slots="$scopedSlots"
                @cell-click="$emit('cell-click', $event)" />
        </div>
    </div>
</template>

<script>
import VirtualTableRow from './VirtualTableRow.vue';
import { calculateVisibleRows } from '../services/virtualScroll';

export default {
    components: {
        VirtualTableRow
    },
    props: {
        items: {
            type: Map,
            required: true
        },
        headers: {
            type: Array,
            required: true
        },
        totalItems: {
            type: Number,
            required: true
        },
        columnWidths: {
            type: Object,
            required: true
        },
        cellHeight: {
            type: Number,
            required: true
        },
        scrollTop: {
            type: Number,
            required: true
        },
        containerHeight: {
            type: Number,
            required: true
        },
        headerHeight: {
            type: Number,
            required: true
        }
    },
    computed: {
        visibleRows() {
            const availableHeight = this.containerHeight - this.headerHeight;
            return calculateVisibleRows(this.scrollTop, availableHeight, this.cellHeight, this.totalItems, this.items);
        },
        windowOffset() {
            if (this.visibleRows.length === 0) return 0;
            return this.visibleRows[0].index * this.cellHeight;
        }
    }
};
</script>

<style scoped>
.virtual-scroll-spacer {
    position: relative;
    width: 100%;
}

.render-window {
    position: absolute;
    top: 0;
    left: 0;
    will-change: transform;
    width: 100%;
}
</style>
